import React from 'react';
import styled from 'styled-components';
import { Loading } from '~web/view/components/core/loading.component';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';

export const DataLoading: React.FunctionComponent = ({ children, ...rest }) => {
  return (
    <Container {...rest}>
      <LoadingContainer>
        <Loading />
      </LoadingContainer>
      {children}
    </Container>
  );
};

const Container = styled(Column)`
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: bold;
  line-height: 26px;
  letter-spacing: 0.35px;
  width: 100%;
  height: 100%;
`;

const LoadingContainer = styled(Box)`
  margin: 15px 0;
`;



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/core/data-loading.component.tsx